import { Box, Typography } from "@material-ui/core"
import { LinksType } from "common/SiteLinks"
import NextLink from "components/Reusable/Bit/NextLink"
import styled from "styled-components"

const StyledFooterLink = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 40px;
  flex-wrap: wrap;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    gap: 20px;
  }
  a {
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-right: 0px;
    }
  }
  .iconWrapper {
    flex-direction: row;
  }
`

const StyledTypography = styled(Typography)`
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.015em;
  text-align: left;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
    line-height: 19.8px;
  }

  :hover {
    text-decoration: underline;
  }
`

type FooterLinkListProps = {
  linkList: LinksType[]
}

const FooterLinkList = ({ linkList }: FooterLinkListProps) => {
  return (
    <StyledFooterLink>
      {linkList.map((item, index) => {
        return (
          <NextLink href={item.link} key={index} openInNewTab={item.blank}>
            <Box>
              <StyledTypography>
                {item.link.includes("whatsapp") && (
                  <Typography variant="srOnly">
                    "פניה באמצעות וואטסאפ ומעבר לאפליקציה"
                  </Typography>
                )}
                {item.title}
              </StyledTypography>
            </Box>
          </NextLink>
        )
      })}
    </StyledFooterLink>
  )
}

export default FooterLinkList
